var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15804_69284",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15804_69284)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3541 10.5311H18.75V10.5H12V13.5H16.2386C15.6203 15.2464 13.9586 16.5 12 16.5C9.51488 16.5 7.5 14.4851 7.5 12C7.5 9.51488 9.51488 7.5 12 7.5C13.1471 7.5 14.1908 7.93275 14.9854 8.63963L17.1067 6.51825C15.7673 5.26987 13.9755 4.5 12 4.5C7.85813 4.5 4.5 7.85813 4.5 12C4.5 16.1419 7.85813 19.5 12 19.5C16.1419 19.5 19.5 16.1419 19.5 12C19.5 11.4971 19.4482 11.0062 19.3541 10.5311Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36328 8.50912L7.82741 10.3162C8.49416 8.6655 10.1089 7.5 11.9985 7.5C13.1457 7.5 14.1893 7.93275 14.9839 8.63962L17.1053 6.51825C15.7658 5.26987 13.974 4.5 11.9985 4.5C9.11778 4.5 6.61953 6.12637 5.36328 8.50912Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0011 19.5003C13.9383 19.5003 15.6986 18.7589 17.0295 17.5533L14.7082 15.589C13.9552 16.1594 13.0192 16.5003 12.0011 16.5003C10.0503 16.5003 8.39397 15.2564 7.76997 13.5205L5.32422 15.4049C6.56547 17.8338 9.08622 19.5003 12.0011 19.5003Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3541 10.5311H18.75V10.5H12V13.5H16.2386C15.9416 14.3389 15.402 15.0623 14.706 15.5891C14.7064 15.5888 14.7068 15.5887 14.7071 15.5884L17.0284 17.5526C16.8641 17.7019 19.5 15.75 19.5 12C19.5 11.4971 19.4482 11.0063 19.3541 10.5311Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8a83d21ff474bd22a3840ec0716bb7f3.svg";
export { ForwardRef as ReactComponent };